module.exports = "/packs/images/homepage/activity/swimming_retina~7732479899aa688ab1f4c38b9a697d4a.jpg";